import Seo from '@/components/base/Seo';
import { Link } from 'react-router-dom';

export default function TermsConditions() {
  return (
    <div className="min-h-screen bg-background-50 pt-24 pb-16 px-6">
      <Seo
        title="Terms & Conditions | Healing & Breakthrough"
        description="Terms and Conditions for Healing & Breakthrough. Read our policies regarding coaching services, intellectual property, and user conduct."
        canonicalPath="/terms-and-conditions"
      />
      <div className="max-w-3xl mx-auto">
        <Link
          to="/"
          className="flex items-center gap-2 text-sm font-semibold text-primary-600 hover:text-primary-700 transition-colors cursor-pointer mb-8"
        >
          <i className="ri-arrow-left-line" aria-hidden="true"></i>
          Back to Home
        </Link>
        <h1 className="font-heading text-3xl md:text-4xl font-bold text-primary-800 mb-8">
          Terms & Conditions
        </h1>
        <div className="space-y-6 text-sm text-foreground-600 leading-relaxed">
          <p>
            These terms and conditions outline the rules and regulations for the use of Healing & Breakthrough Coaching&apos;s website.
          </p>

          <h2 className="font-heading text-lg font-semibold text-primary-700 mt-6">
            1. Acceptance of Terms
          </h2>
          <p>
            By accessing this website, we assume you accept these terms and conditions. Do not continue to use this website if you do not agree to all of the terms and conditions stated on this page.
          </p>

          <h2 className="font-heading text-lg font-semibold text-primary-700 mt-6">
            2. Coaching Services
          </h2>
          <p>
            The coaching services provided are not a substitute for professional medical advice, diagnosis, or treatment. Always seek the advice of your physician or other qualified health provider with any questions you may have regarding a medical condition.
          </p>

          <h2 className="font-heading text-lg font-semibold text-primary-700 mt-6">
            3. Intellectual Property
          </h2>
          <p>
            Unless otherwise stated, Healing & Breakthrough Coaching and/or its licensors own the intellectual property rights for all material on this website. All intellectual property rights are reserved.
          </p>

          <h2 className="font-heading text-lg font-semibold text-primary-700 mt-6">
            4. User Conduct
          </h2>
          <p>
            You must not use this website in any way that causes, or may cause, damage to the website or impairment of the availability or accessibility of the website.
          </p>

          <h2 className="font-heading text-lg font-semibold text-primary-700 mt-6">
            5. Limitation of Liability
          </h2>
          <p>
            Healing & Breakthrough Coaching will not be liable for any indirect, incidental, special, consequential, or punitive damages resulting from your use of or inability to use the website or services.
          </p>

          <h2 className="font-heading text-lg font-semibold text-primary-700 mt-6">
            6. Governing Law
          </h2>
          <p>
            These terms and conditions are governed by and construed in accordance with the laws, and you irrevocably submit to the exclusive jurisdiction of the courts in that location.
          </p>

          <h2 className="font-heading text-lg font-semibold text-primary-700 mt-6">
            7. Changes to Terms
          </h2>
          <p>
            We reserve the right to revise these terms at any time. By using this website, you are expected to review these terms on a regular basis.
          </p>

          <p className="pt-4">
            For questions about these terms, please contact{" "}
            <a href="mailto:federica.tedeschi3@gmail.com" className="text-primary-600 hover:underline">
              federica.tedeschi3@gmail.com
            </a>.
          </p>
        </div>
      </div>
    </div>
  );
}